/**
 * @desc 红人领用管理-终止领用
 */
const URL = "/rantion-kol";
import http, { updateResponse } from "@/http";
export type Response = defs.kol.Response;
export function request(
  body: defs.kol.UserCelebrityEndOfUseRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/kol/useCelebrity/endOfUse`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
